import styled from 'styled-components';

import colors from '../../../styles/colors';

export const Wrapper = styled.div`
	display: grid;
	gap: 1rem;
	grid-template-columns: 1fr;
	padding-bottom: 0.5rem;

	.row-line {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid ${colors.neutralForm};
		padding-bottom: 1rem;

		button {
			padding: 0;
		}

		&:last-child {
			border: none;
			padding-bottom: 0;
		}
	}

	.element-info {
		&__title {
			color: ${colors.neutralText};
			margin-bottom: 0.25rem;
		}
	}
`;

export const Form = styled.form`
	position: relative;

	.close-button {
		position: absolute;
		top: 1rem;
		right: 1rem;
		color: ${colors.neutralButton};
	}

	.modal-content {
		display: grid;
		grid-template-columns: 1fr;
		gap: 2rem;
		padding: 4rem 0 0;

		&__header {
			display: grid;
			grid-template-columns: 1fr;
			gap: 0.5rem;
			margin-bottom: 1rem;
		}

		&__section {
			display: grid;
			grid-template-columns: 1fr;
			gap: 1.5rem;
			margin: 0 auto;
			padding: 0 1rem;
			width: 100%;
			max-width: 41.25rem;
		}
	}

	.modal-footer {
		display: flex;
		justify-content: flex-end;
		padding: 1.5rem;
		border-top: 1px solid ${colors.neutralForm};
	}
`;
